/* import __COLOCATED_TEMPLATE__ from './metadata-mapping.hbs'; */
/* RESPONSIBLE TEAM: team-data-foundations */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { set } from '@ember/object';

interface RowData {
  metadataKey: string;
}

interface Args {
  metadataKey?: string;
  onUpdate?: (data: RowData[]) => void;
}

interface Signature {
  Args: Args;
  Element: HTMLElement;
}

export default class MetadataMapping extends Component<Signature> {
  @tracked private tableData: RowData[];

  constructor(owner: unknown, args: Args) {
    super(owner, args);
    this.tableData = [
      {
        metadataKey: args.metadataKey || '',
      },
    ];
  }

  handleInputChange(rowData: RowData, event: Event) {
    set(rowData, 'metadataKey', (event.target as HTMLInputElement).value);
  }

  @action
  handleSave() {
    this.args.onUpdate?.(this.tableData);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Appstore::AppPackage::Settings::Stripe::MetadataMapping': typeof MetadataMapping;
    'appstore/app-package/settings/stripe/metadata-mapping': typeof MetadataMapping;
  }
}
